import React from "react";
import { cratoniData } from "../../../data";

function Cratoni() {
  const { brand, description, history, productDevelopment, distribution } =
    cratoniData;

  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{brand}</h1>
        <p className="text-gray-700 leading-relaxed text-base">{description}</p>
      </div>

      {/* History */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900">History</h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {history.focus}
        </p>
      </div>

      {/* Product Development */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900">
          Product Development
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {productDevelopment.collaboration}
        </p>
      </div>

      {/* Distribution */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900">Distribution</h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {distribution.agreements}
        </p>
      </div>
    </div>
  );
}

export default Cratoni;
